<template>
  <div class="flex flex-col items-center px-4 pt-2 pb-8 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
        class="w-12 rounded-full h-12 flex flex-col items-center justify-center border border-1 border-WHITE bg-LIGHTGREEN"
      >
        <font-awesome-icon size="xl" icon="fa-solid fa-check" />
      </div>

      <div class="flex flex-col">
        <p class="text-md font-semibold pt-6">Withdraw Successful</p>
        <p class="font-normal pt-3 text-xs text-GREY">
          {{ withdrawInfo.content }}
        </p>
      </div>
      <div class="flex flex-col gap-4 px-3.5 py-3 border border-1 rounded-lg w-full mt-5">
        <div class="flex flex-row justify-between gap-4 w-full">
          <p class="font-semibold text-sm">Transaction</p>
          <p class="text-xs">{{ withdrawInfo.date }}</p>
        </div>
        <div class="flex flex-col gap-2.5 relative w-full">
          <div
            class="rounded-lg border border-1 flex flex-row justify-between items-center w-full px-3 py-2.5"
          >
            <div class="flex flex-col gap-0.5 items-start">
              <p class="font-medium text-xs">{{ withdrawInfo.sendToken }}</p>
              <p class="text-xs text-GREY">Change in</p>
            </div>
            <p class="text-lg font-medium">{{ withdrawInfo.sendAmount }}</p>
          </div>
          <div
            class="rounded-lg border border-1 flex flex-row justify-between items-center w-full px-3 py-2.5"
          >
            <div class="flex flex-col gap-0.5 items-start">
              <p class="font-medium text-xs">{{ withdrawInfo.recriveToken }}</p>
              <p class="text-xs text-GREY">Change to</p>
            </div>
            <p class="text-lg font-medium">{{ withdrawInfo.recriveAmount }}</p>
          </div>
          <div
            class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-WHITE w-8 h-8 rounded-full"
          >
            <font-awesome-icon
              class="rotate-90 p-2 black-icon"
              icon="fa-solid fa-arrow-right-arrow-left"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6 pt-6 items-center w-full pb-3">
      <pow-button secondary class="w-full" :loading="loading">
        <p>Close</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import PowButton from '@/components/PowButton.vue'
import { ref } from 'vue'


const props = defineProps({
  withdrawInfo: {
    type: Object,
    required: true
  },
})
const loading = ref(false)
</script>
